import EmailEditor from 'react-email-editor';

export default EmailEditor;
